import { Component, OnInit, EventEmitter, OnDestroy } from '@angular/core';
import { Channel } from './includes/IPTV_Editor/iptv_editor.component';
import { DCInput } from './includes/dynamic_components/dynamic.service';

@Component({
    selector: 'iptv-channel',
    template: `<dialog-window [title]="title" (close)="close()"  focusOnCloseButton="true">
                <form (ngSubmit)="submit()" ngNativeValidate  style="text-align: right; font-style: italic; color: #41687e; 
                                                                        background: linear-gradient(to bottom, rgb(254,254,254) 0%, rgb(254,254,254) 50%, rgb(232,232,232) 100%);
                                                                        margin: -5px;
                                                                        padding: 5px;" 
                                                                        id="channelChange">
                    <div class="main_logo blue-button"><img [src]="icon.search('http') === 0 ? icon : ( icon ? '/img/tvicons/'+icon : '/img/tvicons/icon')" 
                    style="" alt="ICON"
                    (error)="$event.target.src = '/img/tvicons/error'" /></div>
                    <label>Название: 
                    <input type="text" [(ngModel)]="name" name="name" class="input-gray" required style="padding: 3px;"/></label><br>
                    <label >URL: 
                    <input type="text" [(ngModel)]="url" name="index" class="input-gray"  required  style="margin: 5px 0; padding: 3px;" /></label><br>
                    <label >EPG-id: 
                    <input type="text" [(ngModel)]="tvg_id" name="tvg_id" class="input-gray"  style="margin: 5px 0; padding: 3px;" /></label><br>
                    <label >Logo: 
                    <input type="text" [(ngModel)]="icon" name="icon" class="input-gray"  style="margin: 5px 0; padding: 3px;" /></label><br>
                </form>
                <div dialog-footer style="text-align: center;"><button type="submit" form="channelChange" class="blue-button">Сохранить</button></div>
                </dialog-window>
                `,
        styleUrls: ["./iptv.channel.component.css"],
})
/**
 * Форма для редактирования канала
 */
export class IPTVChannelComponent implements OnInit, OnDestroy, DCInput {
    title:string = "Редактирование канала ";
    name:string = "";
    url: string = "";
    tvg_id:string = "";
    icon:string = "dummy_tv.jpg";
    private _channel:Channel = {name: "Имя", url: 'http://', group_id: 1, tvg_id: null, icon: null};
    /**
     * Отправляет канал, при сохранении.
     */
    onSubmit:EventEmitter<Channel> = new EventEmitter();
    destroyEmitter:EventEmitter<null> = new EventEmitter();
    constructor() { }

    ngOnInit() { 
    }
    ngOnDestroy(){
        this.destroyEmitter.complete();
    }
    set channel(ch:Channel){
        this._channel = ch;
        this.name = ch.name;
        this.url = ch.url;
        this.tvg_id = ch.tvg_id;
        this.icon = ch.icon;
    }
    get channel(){
        return this._channel;
    }
    submit(){
        this.channel.name = this.name;
        this.channel.url = this.url;
        this.channel.tvg_id = this.tvg_id;
        this.channel.icon = this.icon;
        this.onSubmit.emit(this.channel);
        this.close();
    }
    /**
     * Закрывает окно
     */
    close(){
        this.destroyEmitter.emit(null);
    }
}